export default __webpack_public_path__ + "static/media/Kunal_Upadhyay.689b443b.png";